import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaAnyDefinition } from './TypedDefinition'

export const SchemaAnyPlugin = createSchemaPlugin(
  'Schema.Any',
  SchemaAnyDefinition
)
